import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ManagerDashboardService } from '../services/manager-dashboard.service';
import { LoggingService } from '../services/logging.service';
import { User } from '../models/user';
import { Team } from '../models/team';
import { TenantRouterService } from '../services/tenant-router.service';
declare var bootstrap: any;


@Component({
  selector: 'app-team-users',
  standalone: false,
  templateUrl: './team-users.component.html',
  styleUrl: './team-users.component.scss'
})
export class TeamUsersComponent implements OnInit {
  teamId!: number;
  users: any[] = [];
  teamName: string = '';
  showAddUserModal = false;
  managerId!: number;
  teamSubscription: any;
  selectFileData: any;
  errorMessage: string = '';
  successMessage: string = '';

  @ViewChild('userModal', { static: false }) userModalEl!: ElementRef;
  @ViewChild('userToast') teamToastEl!: ElementRef;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private dashboardService: ManagerDashboardService,
    private loggingService: LoggingService,
    private tenantRouter: TenantRouterService
  ) { }

  ngOnInit(): void {
    this.teamId = +this.route.snapshot.paramMap.get('teamId')!;
    const managerid = sessionStorage.getItem('manager_id');
    if (managerid) {
      this.managerId = parseInt(managerid, 10);
    }
    this.teamSubscription = this.dashboardService.getAllTeams(this.managerId).subscribe(
      (teams: Team[]) => {
        this.loggingService.logDebug("Fetched teams for manager: " + this.managerId);
        const selectedTeam = teams.find(team => team.teamId === this.teamId);

        if (selectedTeam) {
          this.teamName = selectedTeam.name;
          this.users = selectedTeam.users || [];
        } else {
          this.loggingService.logError("Team not found in API response");
        }
      },
      (error) => {
        this.loggingService.logError("Error fetching teams: " + error);
      }
    );
  }

  openAddUserModal() {
    this.showAddUserModal = true;

    // If you want to open Bootstrap modal directly instead of *ngIf
    const modalEl = document.getElementById('addUserModal');
    if (modalEl) {
      const modal = bootstrap.Modal.getOrCreateInstance(modalEl);
      modal.show();
    }
  }

  ngAfterViewInit() {
    document.addEventListener('hidden.bs.modal', () => {
      document.querySelectorAll('.modal-backdrop').forEach(backdrop => backdrop.remove());
      document.body.classList.remove('modal-open');
      document.body.style.removeProperty('padding-right');
    });
  }

  goback() {
    this.tenantRouter.navigate('register-dashboard');
  }

  onUserAdded(newUser: User) {
    this.users.push(newUser);

    const modalEl = document.getElementById('addUserModal');
    const modal = bootstrap.Modal.getOrCreateInstance(modalEl!);

    // Listen once for cleanup after closing
    modalEl?.addEventListener('hidden.bs.modal', () => {
      document.body.classList.remove('modal-open');
      document.body.style.removeProperty('padding-right');

      const backdrop = document.querySelector('.modal-backdrop');
      if (backdrop) {
        backdrop.remove();
      }
    }, { once: true });

    modal.hide();

    const toast = new bootstrap.Toast(this.teamToastEl.nativeElement, { delay: 3000 });
    toast.show();
  }

  selectedFile(event: Event) {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      this.selectFileData = input.files[0];
      this.successMessage = '';
      this.errorMessage = '';
    }
  }

  uploadFiles() {
    if (!this.selectFileData) {
      this.loggingService.logDebug("No Files selected");
      alert("Please select an Excel file first.");
      return;
    }
    const formData = new FormData();
    formData.append('file', this.selectFileData);
    this.dashboardService.createBulkUser(formData, this.teamId, this.managerId).subscribe({
      next: (res) => {
        if (res.errorMessage) {
          this.errorMessage = "Bulk upload failed: " + res.errorMessage;
          // Backend validation errors returned as string
          alert("Validation Errors:\n" + res.errorMessage);
          this.loggingService.logError("Bulk upload failed: " + res.errorMessage);
        } else {
          this.successMessage = "Bulk upload success: " + res.successMessage
          // Success
          alert(res.successMessage || "Users imported successfully!");
          this.loggingService.logDebug("Bulk upload success: " + res.successMessage);

          // Reset file input variable
          this.selectFileData = null;

          // Refresh the user table list
          this.ngOnInit();
        }
      },
      error: (err) => {
        this.loggingService.logError("Error uploading file: " + err);
        alert("An error occurred during upload. Please try again.");
      }
    });

  }
}





